/**
 * Created by vtbelo on 17/03/21
 */

const MonstersPlanner = function (slot) {
    this.slot = slot;
    this.fresh = 0;

    if (!Map2d.currentMap.regions.monsters) {
        return;
    }

    if (cleverapps.config.editorMode || cleverapps.config.adminMode) {
        return;
    }

    if (this.getCurrentMonster()) {
        this.load();

        const timeout = cleverapps.parseInterval(MonstersPlanner.RESET_TIMEOUT);
        if (this.spawnTime + timeout < Date.now()) {
            this.spawnToAllSlots();
        } else {
            this.planNext();
        }
    }
};

MonstersPlanner.prototype.destructor = function () {
    this.clearPlanTimeout();
};

MonstersPlanner.prototype.clearPlanTimeout = function () {
    if (this.planTimeout !== undefined) {
        clearTimeout(this.planTimeout);
        this.planTimeout = undefined;
    }
};

MonstersPlanner.prototype.spawnToAllSlots = function (needStory) {
    this.clearPlanTimeout();

    const slots = this.getFreeSlots();
    if (!slots.length) {
        return;
    }

    this.needStory = needStory;
    this.spawnOrder = 0;
    this.spawnTime = Date.now();

    this.save();

    for (let i = 0; i < slots.length; ++i) {
        this.spawnMonster();
    }
};

MonstersPlanner.prototype.removeWrongMonsters = function () {
    const currentMonster = this.getCurrentMonster();
    const units = Map2d.currentMap.listAvailableUnits((unit) => unit.getData().monster);

    let region = Map2d.currentMap.regions.monsters;
    region = region && region.positions || [];

    units.forEach((unit) => {
        const inRegion = region.some((cell) => cell.x === unit.x && cell.y === unit.y);

        if (!inRegion || unit.getData().monster !== currentMonster) {
            unit.findComponent(Monster).die(true);
        }
    });
};

MonstersPlanner.prototype.getFreeSlots = function () {
    return Map2d.currentMap.regions.monsters.positions.filter((position) => {
        const monster = Map2d.currentMap.getUnit(position.x, position.y);
        return !monster;
    });
};

MonstersPlanner.prototype.spawnMonster = function () {
    this.fresh += 1;
    this.save();
    Map2dLocation.currentLocation.counter.trigger(100);
};

MonstersPlanner.prototype.processFresh = function () {
    if (!this.fresh || cleverapps.focusManager.isFocused() || Map2d.currentMap.dragging) {
        return;
    }

    const monster = this.getCurrentMonster();
    let slots = this.getFreeSlots();
    if (!monster || !slots.length) {
        this.fresh = 0;
        return;
    }

    const pseudo = PseudoRandom.GET("secondary");
    pseudo.randomSeed();

    slots = pseudo.shuffle(slots);

    const storyUnit = MonstersPlanner.monsters[monster].units[0] || {};
    const story = this.needStory && Map2dLocation.currentLocation.unitStories.findStory(Unit.GetKey(storyUnit));

    const actions = []; 

    for (let i = 0, last = Math.min(this.fresh, slots.length) - 1; i <= last; ++i) {
        const slot = slots[i];
        const unit = pseudo.choose(MonstersPlanner.monsters[monster].units);

        if (story && i === last) {
            actions.push(((unitData, cell, f) => {
                const monsterUnit = new Unit(unitData);
                monsterUnit.findComponent(Monster).spawn(cell, 2);

                Map2dLocation.currentLocation.unitStories.showUnitStory(f, story.dialogue, {
                    unit: monsterUnit,
                    tutorial: Map2dLocation.currentLocation.unitStories.getTutorial(story.id),
                    delay: 2000
                });
            }).bind(this, storyUnit, slot));
            break;
        }

        actions.push(((cell, f) => {
            Map2d.currentMap.focusOnUnit(cell, {
                allowScrollWithFocus: true,
                callback: f
            });
        }).bind(this, slot));

        actions.push(((unitData, cell, f) => {
            const monsterUnit = new Unit(unitData);
            monsterUnit.findComponent(Monster).spawn(cell);

            setTimeout(f, 2000);
        }).bind(this, unit, slot));

        if (i === last) {
            actions.push(((cell, f) => {
                if (Map2d.currentMap.advice) {
                    Map2d.currentMap.advice.setLogic(Map2d.CLICK_UNIT, {
                        cells: cell
                    });
                    Map2d.currentMap.advice.startHintOnce();
                }
                setTimeout(f, Map2dAdvice.ONE_ITERATION_DURATION);
            }).bind(this, slot));
        }
    }

    this.fresh = 0;
    this.needStory = false;

    this.spawnTime = Date.now();
    this.spawnOrder++;
    this.save();

    this.planNext();

    cleverapps.focusManager.display({
        focus: "SpawnMonsters",
        actions
    });
};

MonstersPlanner.prototype.save = function () {
    this.slot.save("local_monster_planner", {
        fresh: this.fresh,
        time: this.spawnTime,
        order: this.spawnOrder
    });
};

MonstersPlanner.prototype.load = function () {
    const data = this.slot.load("local_monster_planner");
    if (data) {
        this.fresh = data.fresh;
        this.spawnTime = data.time;
        this.spawnOrder = data.order;
    }

    this.fresh = this.fresh || 0;
    this.spawnOrder = this.spawnOrder || 0;
    this.spawnTime = Math.min(this.spawnTime || Date.now(), Date.now());

    this.save();
};

MonstersPlanner.prototype.onDieMonster = function () {
    if (this.planTimeout === undefined) {
        this.spawnTime = Date.now();
        this.spawnOrder = 0;
        this.save();
        this.planNext();
    }
};

MonstersPlanner.prototype.stop = function () {
    this.clearPlanTimeout();
    this.removeWrongMonsters();
};

MonstersPlanner.prototype.planNext = function () {
    this.clearPlanTimeout();

    const slots = this.getFreeSlots();
    if (!slots.length) {
        return;
    }

    const timeout = cleverapps.parseInterval(MonstersPlanner.BETWEEN_TIMEOUTS[this.spawnOrder] || MonstersPlanner.BETWEEN_TIMEOUTS[MonstersPlanner.BETWEEN_TIMEOUTS.length - 1]);
    let waitTime = cleverapps.parseInterval(MonstersPlanner.SMALL_TIMEOUT);
    if (this.spawnTime + timeout > Date.now()) {
        waitTime = this.spawnTime + timeout - Date.now();
    }

    this.planTimeout = setTimeout(() => {
        this.clearPlanTimeout();
        this.spawnMonster();
    }, waitTime);
};

MonstersPlanner.prototype.getCurrentMonster = function () {
    const mission = cleverapps.missionManager.findByType(Mission.TYPE_KRAKENFEAST);
    if (mission && mission.isRunning()) {
        return "kraken";
    }

    return undefined;
};

MonstersPlanner.SMALL_TIMEOUT = "1 seconds";
MonstersPlanner.RESET_TIMEOUT = "1 hour";
MonstersPlanner.BETWEEN_TIMEOUTS = ["20 minutes", "20 minutes", "20 minutes", "30 minutes", "30 minutes", "30 minutes", "30 minutes", "1 hour"];

MonstersPlanner.monsters = {
    kraken: {
        units: [{
            code: "kraken",
            stage: 0
        }, {
            code: "kraken",
            stage: 1
        }, {
            code: "kraken",
            stage: 2
        }]
    }
};